import { create } from 'zustand';

type Theme = 'light' | 'dark';

const STORAGE_KEY = 'gt-theme';

const readInitial = (): Theme => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

interface ThemeState {
  theme: Theme;
  toggle: () => void;
  set: (theme: Theme) => void;
}

/**
 * The class is applied by an inline script in index.html before first paint,
 * so a dark-mode user never sees a light flash. This store keeps React in sync
 * with what that script already did.
 */
export const useTheme = create<ThemeState>((set) => ({
  theme: readInitial(),
  set: (theme) => {
    localStorage.setItem(STORAGE_KEY, theme);
    document.documentElement.classList.toggle('dark', theme === 'dark');
    set({ theme });
  },
  toggle: () =>
    set((state) => {
      const next: Theme = state.theme === 'dark' ? 'light' : 'dark';
      localStorage.setItem(STORAGE_KEY, next);
      document.documentElement.classList.toggle('dark', next === 'dark');
      return { theme: next };
    }),
}));
